import {
  AppBar,
  Box,
  Button,
  IconButton,
  styled,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import FlexBox from 'components/flexbox/FlexBox';
import { H6 } from 'components/Typography';
import { Check, MoreHorizontal, X } from 'lucide-react';

const StyledToolBar = styled(Toolbar)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 24px',
  minHeight: '64px',
}));

const HeaderRoot = styled(AppBar)(({ theme }) => ({
  zIndex: 1201,
  boxShadow: 'none',
  width: '100%',
  backgroundColor: '#ffffff',
  color: theme.palette.text.primary,
  position: 'sticky',
  top: 0,
  borderBottom: '1px solid #E1E1E1',
}));

const StatusChip = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: '#f0f9ff',
  color: '#0284c7',
  padding: '4px 8px',
  borderRadius: '16px',
  fontSize: '12px',
  fontWeight: 500,
}));

export default function CourseUploadHeader({
  courseTitle = '1인 AI 스타트업 개발',
  onClose,
  onSave,
  onSubmit,
  onPreview,
}) {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <HeaderRoot position="sticky">
      <StyledToolBar>
        {/* Left side - Course title and status */}
        <FlexBox alignItems="center" gap={2}>
          <H6
            fontWeight={600}
            color={theme.palette.text.primary}
            sx={{ fontSize: '16px' }}
          >
            {courseTitle}
          </H6>
          {!isTablet && (
            <StatusChip>
              <Check size={12} />
              임시저장
            </StatusChip>
          )}
        </FlexBox>

        {/* Right side - Action buttons */}
        <FlexBox alignItems="center" gap={1}>
          {!isTablet ? (
            <>
              <Button
                variant="primary"
                sx={{
                  backgroundColor: theme.palette.primary.white,
                  border: `1px solid ${theme.palette.primary.borderColor}`,
                  color: theme.palette.primary.dark,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.grey700,
                  },
                }}
              >
                강의 보기
              </Button>
              <Button
                variant="secondary"
                sx={{
                  backgroundColor: theme.palette.primary.darkBlue,
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: theme.palette.primary.darkBlueHover,
                  },
                }}
              >
                저장
              </Button>
              <Button
                variant="primary"
                sx={{
                  backgroundColor: theme.palette.primary.white,
                  border: `1px solid ${theme.palette.primary.borderColor}`,
                  color: theme.palette.primary.dark,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.grey700,
                  },
                }}
              >
                제출
              </Button>

              <IconButton
                size="small"
                sx={{
                  color: theme.palette.text.secondary,
                  '&:hover': { backgroundColor: '#f5f5f5' },
                }}
              >
                <MoreHorizontal size={20} />
              </IconButton>

              <IconButton
                size="small"
                sx={{
                  color: theme.palette.text.secondary,
                  '&:hover': { backgroundColor: '#f5f5f5' },
                }}
              >
                <X size={20} />
              </IconButton>
            </>
          ) : (
            <>
              <Button
                variant="secondary"
                sx={{
                  backgroundColor: theme.palette.primary.darkBlue,
                  color: '#fff',
                  '&:hover': {
                    backgroundColor: theme.palette.primary.darkBlueHover,
                  },
                  minWidth: 'auto',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: 500,
                  textTransform: 'none',
                }}
              >
                저장
              </Button>
              <Button
                variant="primary"
                sx={{
                  backgroundColor: theme.palette.primary.white,
                  border: `1px solid ${theme.palette.primary.borderColor}`,
                  color: theme.palette.primary.dark,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.grey700,
                  },
                  minWidth: 'auto',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: 500,
                  textTransform: 'none',
                }}
              >
                제출
              </Button>
            </>
          )}
        </FlexBox>
      </StyledToolBar>
    </HeaderRoot>
  );
}
